// extracted by mini-css-extract-plugin
module.exports = {"emailIndicator":"EmailIndicator_emailIndicator__4x02a","isSending":"EmailIndicator_isSending__214fD","isFailed":"EmailIndicator_isFailed__vALXv"};